import Repository from './Repository'
import { options } from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.pcmApi}/`
const resourceCrm = `${options.baseURL}/`

export default {
  async create(params) {
    const response = await Repository.post(`${resource}promotions`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getList(params) {
    const response = await Repository.get(`${resource}promotions`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListActive(params) {
    const response = await Repository.get(`${resource}promotions/available`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getDetail(id) {
    const response = await Repository.get(`${resource}promotions/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async addition(id, body) {
    const response = await Repository.patch(`${resource}promotions/${id}/addition`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  
  async getHistory(id, params) {
    const response = await Repository.get(`${resource}promotions/${id}/promotion-usage-logs`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportPromotion(id) {
    const response = await Repository.get(`${resource}promotions/${id}/export-promotion-subs`, {
      headers: TokenService.getHeader(),
    })
    return response
  }
}
